import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaMiddle';
const args = {};

export class OligonKentimaMiddle extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
